export default {
  header: 'Não foi possível carregar o seu pedido',
  text: 'Ocorreu um erro ao preparar o seu pedido. O seu cesto está seguro — tente novamente.',
  retry: 'Tentar novamente',
  address_header: 'Precisamos da sua morada de entrega',
  address_text: 'Não conseguimos calcular o total até sabermos onde entregar. O seu carrinho está seguro.',
  address_action: 'Adicionar morada de entrega',
  back_checkout: 'Voltar ao seu pedido',
  back_basket: 'Voltar ao seu carrinho',
};
